// src/components/InstituteBanner.jsx
// Extracted from Dashboard.jsx (PLAN S11a's institution partner banner) so
// StudentPortal.jsx's DashboardHome section can reuse it without duplicating
// the fetch/JSX. Logic is unchanged from the original - same two fetches,
// same silent-fail behavior, same gating on user_type==='student' &&
// institution_id.
import React, { useState, useEffect } from 'react';
import { baseUrl } from '../config';

const InstituteBanner = () => {
  const [institution, setInstitution] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (!token) return;
    (async () => {
      try {
        const userRes = await fetch(`${baseUrl}/getUserById`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!userRes.ok) return;
        const user = await userRes.json();
        if (user.user_type !== 'student' || !user.institution_id) return;

        const instRes = await fetch(`${baseUrl}/student-program/my-institution`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (instRes.ok) setInstitution(await instRes.json());
      } catch (_) {
        // Silent - banner just doesn't render, doesn't block the rest of the page.
      }
    })();
  }, []);

  if (!institution) return null;

  return (
    <div
      className="flex items-center gap-4 rounded-2xl border-2 border-teal-200 p-4 mb-6 bg-gradient-to-r from-teal-50 to-cyan-50"
      style={institution.brand_accent_color ? { borderColor: institution.brand_accent_color } : undefined}
    >
      {institution.logo_url ? (
        <img
          src={institution.logo_url}
          alt={institution.name}
          className="w-14 h-14 rounded-lg object-cover flex-shrink-0"
        />
      ) : (
        <div className="w-14 h-14 rounded-lg bg-gradient-to-br from-teal-600 to-cyan-600 flex items-center justify-center text-white font-bold text-xl flex-shrink-0">
          {institution.name.charAt(0)}
        </div>
      )}
      <div className="min-w-0">
        <p className="text-xs font-medium text-teal-600 uppercase tracking-wide">Student Program Partner</p>
        <h2 className="text-lg font-bold text-slate-800 truncate">{institution.name}</h2>
        <div className="flex flex-wrap gap-2 mt-1.5">
          {institution.academy_plan_name && (
            <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-white text-teal-700 border border-teal-200">
              {institution.academy_plan_name}
            </span>
          )}
          {institution.free_period_months > 0 && (
            <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-white text-teal-700 border border-teal-200">
              {institution.free_period_months} months free
            </span>
          )}
          {institution.free_tool_limit > 0 && (
            <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-white text-teal-700 border border-teal-200">
              {institution.free_tool_limit} free tool{institution.free_tool_limit !== 1 ? 's' : ''}
            </span>
          )}
          {institution.discount_percent > 0 && (
            <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-white text-teal-700 border border-teal-200">
              {institution.discount_percent}% off
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default InstituteBanner;
